
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19.5 19.5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.25 10.816v3.25h3.25v2.184h-3.25v3.25h-2.184v-3.25h-3.25v-2.184h3.25v-3.25h2.184zm-16.25 0h8.684V19.5H0v-8.684zM10.816 0H19.5v8.684h-8.684V0zM0 0h8.684v8.684H0V0z"}})])
          )
        }
      }
    